// custom typefaces
import "@fontsource-variable/montserrat"
import "@fontsource/merriweather"
// normalize CSS across browsers
import "./src/normalize.css"
// custom CSS styles
import "./src/style.css"

// Highlighting for code blocks
import "prismjs/themes/prism.css"

import './src/styles/global.css'


import React from "react";
import { LoadingProvider } from "./src/context/LoadingContext";

export const wrapRootElement = ({ element }) => (
  <LoadingProvider>{element}</LoadingProvider>
);
